import type { SyncStorageEngine } from '../types/storage-engine.interface';
import { clearStorageExcept } from './clear-storage-except';

export class LocalStorageEngine implements SyncStorageEngine {
	public clear(): void {
		this.storage?.clear();
	}

	public clearExcept(keys: string[]): void {
		clearStorageExcept(this.storage, keys);
	}

	public get<T = unknown>(key: string): T | null {
		try {
			const rawValue = this.storage?.getItem(key);

			if (rawValue == null) {
				return null;
			}

			return JSON.parse(rawValue) as T;
		} catch {
			return null;
		}
	}

	public getRaw(key: string): string | null {
		try {
			return this.storage?.getItem(key) ?? null;
		} catch {
			return null;
		}
	}

	public set<T = unknown>(key: string, value: T): void {
		try {
			const serialized = JSON.stringify(value);
			this.storage?.setItem(key, serialized);
		} catch {
			/* noop */
		}
	}

	public remove(key: string): void {
		try {
			this.storage?.removeItem(key);
		} catch {
			/* noop */
		}
	}

	private get storage(): Storage | null {
		if (typeof window === 'undefined') {
			return null;
		}

		try {
			return window.localStorage;
		} catch {
			return null;
		}
	}
}
